import { render } from "./FooterInfo.vue?vue&type=template&id=d02433a6"
import script from "./FooterInfo.vue?vue&type=script&lang=js"
export * from "./FooterInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__